import { Base } from './base';
export class SnaplineManager extends Base {
    constructor() {
        super(...arguments);
        this.widget = this.graph.hook.createSnapline();
    }
}
//# sourceMappingURL=snapline.js.map